import { Component, OnInit, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';
import { DatePipe } from '@angular/common';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IFRNota } from '../../notes/notes.interfaces';
import { NotesService } from '../../notes/notes.service';
import { DialogSeguimentTecnic } from '../seguiment-tecnic/dialog.component.seguiment-tecnic';

import { ISeguimentTecnic, IProjectSeguimentTecnicResponse } from '../../manage-seguiment-tecnic-projectes/manage-seguiment-tecnic.interfaces';
import { ManageSeguimentTecnicService } from '../../manage-seguiment-tecnic-projectes/manage-seguiment-tecnic.service';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

import * as moment from 'moment';

@Component({
  selector: 'dialog-notes',
  templateUrl: './dialog.component.notes.html',
  styleUrls: ['./dialog.component.notes.scss'],
  providers: [NotesService, ManageSeguimentTecnicService, DatePipe]
})

export class DialogNotes {
  public error: string = '';
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editNotesData: IFRNota;
  public userInfo: any = {};
  public seguimentsTreballs: any;
  public seguiment_tr: number = null;
  public quillPos: number = 0;
  public showDialog: boolean = false;
  private seguimentTecnicModel: ISeguimentTecnic = {
    'id': 'NEW',
    'projecte_codi': '',
    'titol': '',
    'ambit_proposta': '',
    'tipus': '',
    'sub_tipus': '',
    'participants': '',
    'assumpte': '',
    'data': '',
    'data_realitzacio': '',
    'hora': '',
    'acords': '',
    'lliuraments': '',
    'filename': '',
    'file': null,
    'data_avis': '',
    'avis_actiu': true,
    'lloc': ''
  };
  public editSeguimentTecnicData: ISeguimentTecnic;
  public seguimentTecnicData: IProjectSeguimentTecnicResponse;

  @ViewChild('quillEditor', { static: false }) editor;

  constructor(public translate: TranslateService, public languageService: LanguageService, private manageSeguimentTecnicService: ManageSeguimentTecnicService, private datePipe: DatePipe, private notesService: NotesService, public dialogRef: MatDialogRef<DialogNotes>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any){ 
   this.editNotesData = data.nota;
   if(!this.editNotesData.observacions)this.editNotesData.observacions = "";
   if(!this.dia)this.dia = moment().format("YYYY-MM-DD");
   this.userInfo = data.user;

   this.notesService.getAutocomplete('seguiments', this.editNotesData.id).subscribe(consorci => this.seguimentsTreballs = consorci, err => {return;});

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.editNotesData.data = this.datePipe.transform(new Date(),"yyyy-MM-dd");
    this.editNotesData.observacions = this.editor.quillEditor.root.innerHTML;
    this.dialogRef.close(this.editNotesData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  ngOnInit(){ }

  afegir(event){
    //data
    if(!event && this.editNotesData.observacions.indexOf("[" + this.dia + "]") == -1)
      this.editNotesData.observacions = "[" + this.dia + "] ("+this.userInfo.name+"): <p>&nbsp;</p>" + (this.editNotesData.observacions?this.editNotesData.observacions:'') + "<p>&nbsp;</p>";
    //seguiment
    if(event){
      this.seguiment_tr = event.value;
      this.editor.quillEditor.format('color', 'dark-green'); 
      this.editor.quillEditor.insertText(this.quillPos, "★ "+event.source.triggerValue+" ★", {'color': '#009900','bold': true});
    }
  }

  afegirE(){
    if(!this.editNotesData.nota_e || this.editNotesData.nota_e.indexOf("[" + this.dia + "]") == -1)
      this.editNotesData.nota_e = "[" + this.dia + "] ("+this.userInfo.name+"): \r\n" + (this.editNotesData.nota_e?this.editNotesData.nota_e:'') + "\r\n";
  }

  setPos(event){
    if(event.range)this.quillPos = event.range.index;
    else if(event.oldRange)this.quillPos = event.oldRange.index;
  }

  public editSeguimentTecnic(): void {if(!this.seguiment_tr)return;

    this.seguimentTecnicModel = this.seguimentsTreballs.find(seguiment => seguiment.id == this.seguiment_tr);
    if(!this.seguimentTecnicModel) return;

    this.editSeguimentTecnicData = Object.assign(
      {},
      this.seguimentTecnicModel,
      this.seguiment_tr
    );

   let dialogSegTecRef=this.dialog.open(DialogSeguimentTecnic, {disableClose: true, width: '850px', height: '550px', data: this.editSeguimentTecnicData })
   
   dialogSegTecRef.afterClosed().subscribe(results => {
     if(!results)return;
     this.editSeguimentTecnicData = results;
     this.addOrUpdateUser();
   });
  }

  public addSeguimentTecnic(): void {
    this.editSeguimentTecnicData = Object.assign(
      {},
      this.seguimentTecnicModel,
      { projecte_codi : this.editNotesData.id }
    );

    let dialogSegTecRef=this.dialog.open(DialogSeguimentTecnic, {disableClose: true, width: '850px', height: '550px', data: this.editSeguimentTecnicData })
   
    dialogSegTecRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editSeguimentTecnicData = results;
      this.addOrUpdateUser();
    });
  }

  public addOrUpdateUser(/*$event*/): void {
    this.showAsyncProgress = true;
    this.showDialog = false;
    if(this.editSeguimentTecnicData.id === 'NEW'){
      if(!(new Date(this.editSeguimentTecnicData.data_avis) instanceof Date))this.editSeguimentTecnicData.data_avis = null;
      this.manageSeguimentTecnicService.create(this.editSeguimentTecnicData)
        .subscribe(newSeguiment => {
          this.notesService.getAutocomplete('seguiments', this.editNotesData.id).subscribe(consorci => this.seguimentsTreballs = consorci, err => {return;});
          this.showAsyncProgress = false;
        },err => console.log(err));
    }else {
      this.manageSeguimentTecnicService.update(<number> this.editSeguimentTecnicData.id, this.editSeguimentTecnicData)
        .subscribe(updatedSeguiment => {
          this.seguimentTecnicData.seguiments = this.seguimentTecnicData.seguiments.map(seguiment => {
            return (seguiment.id === updatedSeguiment.id ? updatedSeguiment : seguiment);
          },
          err => console.log(err)
        );
          this.showAsyncProgress = false;
        });
    }
  }

}
